import React, { useState, useEffect } from 'react';

function LayoutBuilder({ onSave }) {
  const availableComponents = {
        topBars: ['TopBar1','TopBar3','TopBar4','TopBar5','TopBar6','TopBar7','TopBar8','TopBar9','TopBar10'],
    headers: ['TemplateHeader1', 'TemplateHeader2', 'TemplateHeader3','TemplateHeader4','TemplateHeader5','TemplateHeader6','TemplateHeader7','TemplateHeader8','TemplateHeader9','TemplateHeader10'],
    heroes: ['TemplateHero1', 'TemplateHero2'],
    sections: ['FeaturedPackages1', 'FeaturedPackages2'],
    footers: ['TemplateFooter1', 'TemplateFooter2', 'TemplateFooter3'],
  };

  const [layout, setLayout] = useState({
    topBar: availableComponents.topBars[0],
    header: availableComponents.headers[0],
    hero: availableComponents.heroes[0],
    sections: [],
    footer: availableComponents.footers[0],
  });

  useEffect(() => {
    onSave(layout);
  }, [layout, onSave]);
  
  // A function to handle adding/removing sections from the array
  const handleSectionChange = (e) => {
    const { value, checked } = e.target;
    setLayout(prevLayout => {
        const newSections = checked 
            ? [...prevLayout.sections, value] 
            : prevLayout.sections.filter(s => s !== value);
        return { ...prevLayout, sections: newSections };
    });
  };
  const handleDropdownChange = (part, value) => {
    setLayout(prev => ({ ...prev, [part]: value }));
  };

  return (
    <div className="card">
        <div className="card-header">
            <h5 className="card-title mb-0">Layout Builder</h5>
        </div>
        <div className="card-body">
            {/* Top Bar Selector */}
             <div className="mb-3">
        <label className="form-label">Top Bar Style</label>
        {/* It uses the same pattern as your other dropdowns */}
        <select className="form-select" value={layout.topBar} onChange={e => handleDropdownChange('topBar', e.target.value)}>
          {/* Add a 'None' option to allow templates without a top bar */}
          <option value="None">None</option> 
          {availableComponents.topBars.map(name => <option key={name} value={name}>{name}</option>)}
        </select>
      </div>
            {/* Header Selector */}
            <div className="mb-3">
                <label className="form-label">Header Style</label>
                <select className="form-select" value={layout.header} onChange={e => setLayout(l => ({ ...l, header: e.target.value }))}>
                    {availableComponents.headers.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
            </div>

            {/* Hero Selector */}
            <div className="mb-3">
                <label className="form-label">Hero Style</label>
                <select className="form-select" value={layout.hero} onChange={e => setLayout(l => ({ ...l, hero: e.target.value }))}>
                    {availableComponents.heroes.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
            </div>
            
            {/* Sections Selector */}
            <div className="mb-3">
                <label className="form-label">Page Sections</label>
                {availableComponents.sections.map(name => (
                    <div className="form-check" key={name}>
                        <input className="form-check-input" type="checkbox" value={name} id={name} onChange={handleSectionChange} />
                        <label className="form-check-label" htmlFor={name}>{name}</label>
                    </div>
                ))}
            </div>

            {/* Footer Selector */}
            <div className="mb-3">
                <label className="form-label">Footer Style</label>
                <select className="form-select" value={layout.footer} onChange={e => setLayout(l => ({ ...l, footer: e.target.value }))}>
                    {availableComponents.footers.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
            </div>
        </div>
    </div>
  );
}

export default LayoutBuilder;